module.exports = __webpack_public_path__ + "img/icon-user-like.388ff1d3.svg";